<router-outlet></router-outlet>
<app-dialog></app-dialog>
<app-loader></app-loader>
